const BeforeAfter = () => {
  return (
    <section className="before-after-section">
      <div className="section-container before-after-grid">
        <div className="section-heading">
          <p>Visible transformation</p>
          <h2>Before & After Glow Care</h2>
          <span>
            A focused routine for hydration, barrier support, and a softer skin finish.
          </span>
        </div>

        <div className="comparison-card">
          <div>
            <img
              src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?auto=format&fit=crop&w=700&q=80"
              alt="Before skincare routine without makeup"
            />
            <span>Before</span>
          </div>
          <div>
            <img
              src="https://images.unsplash.com/photo-1616683693504-3ea7e9ad6fec?auto=format&fit=crop&w=700&q=80"
              alt="After skincare glow routine"
            />
            <span>After</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
